module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(this.$route.name == 'IndexPc') ? _c('div', {
    staticClass: "index_header"
  }, [_c('div', {
    staticClass: "index_header_up"
  }, [_c('img', {
    staticClass: "index_header_up_back",
    attrs: {
      "src": require("@/assets/images/mainindex/index_header_up_bg-2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.activity.activity_title) ? _c('div', {
    staticClass: "index_header_up_tips"
  }, [_c('p', [_vm._v(_vm._s(_vm.activity.activity_title) + " 还有")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.activity.end_day))]), _vm._v(" "), _c('p', [_vm._v("天")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "header_direct"
  }, [_c('div', {
    staticClass: "container_wrap header_direct_bg",
    class: this.$route.name == 'CmsList' || this.$route.name == 'CmsDetail' ?
      'header_direct_bg_cms' :
      ''
  }, [_c('div', {
    staticClass: "header_direct_leftNav"
  }, _vm._l((_vm.navDataArr), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "header_direct_leftNav_item",
      class: item.class,
      on: {
        "click": function($event) {
          return _vm.headerNavClickFun(index, item)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "header_direct_rightIcon"
  }, [(_vm.user.id > 0) ? _c('div', {
    staticClass: "headlefticon",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'MineIndex'
      }),
      expression: "{ name: 'MineIndex' }"
    }],
    staticStyle: {
      "color": "#fff",
      "display": "flex",
      "flex-direction": "row",
      "align-items": "center",
      "/*margin-left": "150px",
      "*/\n                font-size": "16px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.user.name) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "headicon"
  }, [_c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'MineIndex'
      }),
      expression: "{ name: 'MineIndex' }"
    }],
    staticClass: "loginbtn",
    staticStyle: {
      "width": "100px",
      "margin-right": "10px"
    }
  }, [_vm._v("个人中心")]), _vm._v(" "), _c('div', {
    staticClass: "loginbtn registerbtn",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.headerNavIconArr), function(item, index) {
    return [(_vm.loginshow) ? _c('div', {
      key: index,
      staticClass: "header_direct_rightIcon_item",
      on: {
        "click": function($event) {
          return _vm.action(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.src,
        "alt": ""
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.name))])]) : _vm._e()]
  })], 2)])])]) : _c('div', {
    staticClass: "others_header"
  }, [_c('div', {
    staticClass: "header_direct"
  }, [_c('div', {
    staticClass: "container_wrap header_direct_bg",
    class: this.$route.name == 'CmsList' || this.$route.name == 'CmsDetail' ?
      'header_direct_bg_cms' :
      ''
  }, [_c('div', {
    staticStyle: {
      "width": "205px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.logo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header_direct_leftNav"
  }, _vm._l((_vm.navDataArr), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "header_direct_leftNav_item",
      class: item.class,
      on: {
        "click": function($event) {
          return _vm.headerNavClickFun(index, item)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "header_direct_rightIcon"
  }, [(_vm.user.id > 0) ? _c('div', {
    staticClass: "headlefticon",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'MineIndex'
      }),
      expression: "{ name: 'MineIndex' }"
    }],
    staticStyle: {
      "color": "#fff",
      "display": "flex",
      "flex-direction": "row",
      "align-items": "center",
      "font-size": "16px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.user.name) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "headicon"
  }, [_c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'MineIndex'
      }),
      expression: "{ name: 'MineIndex' }"
    }],
    staticClass: "loginbtn",
    staticStyle: {
      "width": "100px",
      "margin-right": "10px"
    }
  }, [_vm._v("个人中心")]), _vm._v(" "), _c('div', {
    staticClass: "loginbtn registerbtn",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.headerNavIconArr2), function(item, index) {
    return [(_vm.loginshow) ? _c('div', {
      key: index,
      staticClass: "header_direct_rightIcon_item",
      on: {
        "click": function($event) {
          return _vm.action(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.src,
        "alt": ""
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.name))])]) : _vm._e()]
  })], 2)])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), (this.$route.name != 'Login') ? _c('div', {
    staticClass: "booter"
  }, [_c('div', {
    staticClass: "container_wrap booter_content"
  }, [_c('div', {
    staticClass: "booter_left"
  }, [_c('div', {
    staticClass: "booter_content_title"
  }, [_vm._v("友情链接")]), _vm._v(" "), _c('div', {
    staticClass: "booter_left_list"
  }, _vm._l((_vm.linkList), function(item) {
    return _c('a', {
      key: item.name,
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "booter_mid"
  }, [_c('div', {
    staticClass: "booter_content_title"
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('div', {
    staticClass: "booter_mid_list"
  }, [_c('p', [_vm._v("\n            中国蹦床与技巧协会啦啦操分会@2021\n          ")]), _vm._v(" "), _c('p', [_vm._v("江苏省南京市秦淮区永智路6号四号楼A栋3-303")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'Gbook'
      }),
      expression: "{ name: 'Gbook' }"
    }],
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v("信箱@CCA")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/"
    }
  }, [_vm._v("苏ICP备18049601号-2 法律事务")])])]), _vm._v(" "), _c('div', {
    staticClass: "booter_right"
  }, [_c('div', {
    staticClass: "booter_content_title"
  }, [_vm._v("公众号&APP")]), _vm._v(" "), _c('div', {
    staticClass: "contact-box"
  }, _vm._l((_vm.contactList), function(item, index) {
    return _c('div', {
      staticClass: "contact-img"
    }, [_c('img', {
      attrs: {
        "src": require('../../assets/images/contact/cca-' + (index + 1) + '.png'),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "contact-title",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    })])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.centerDialogVisible,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v("正在建设中~")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.centerDialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.centerDialogVisible = false
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "公众号二维码",
      "visible": _vm.wechatDialogVisible,
      "width": "300px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.wechatDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "tc"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require('../../assets/images/contact/cca-2.png'),
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container_wrap",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "container-btn"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5517d103","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/IndexLayout.vue
// module id = 1489
// module chunks = 0